import { withField } from '../with-field';

import { FuelTextField } from '@frete.com/fuel-react';
import { useRef } from 'react';

import { FuelTextFieldCustomEvent, FuelTextFieldEventProps } from '@/__mocks__/components';
import { maskInputValue, monetaryFormat } from '@/utils';

import { TextFieldProps } from './type';

export const TextField = ({ onChange, name, mask = '', currency, ...props }: TextFieldProps) => {
  const localInputReference = useRef<HTMLFuelTextFieldElement>(null);

  const setInputValue = (value: string) => {
    localInputReference.current.value = value;
    onChange?.({ target: { value, name } });
  };

  const handleMaskedValue = (value: string) => {
    let currentMask = mask as string;

    if (Array.isArray(mask)) {
      const currentMaskIndex = mask.findIndex((item) => value.length <= item.length);
      const foundMask = mask[currentMaskIndex];
      const lastMask = mask[mask.length - 1];
      currentMask = foundMask ?? lastMask;
    }

    setInputValue(maskInputValue(value, currentMask));
  };

  const convertCustomEventToChange = ({ detail: { value } }: FuelTextFieldCustomEvent<FuelTextFieldEventProps>) => {
    if (mask) handleMaskedValue(value);
    else if (currency) setInputValue(monetaryFormat(value));
    else setInputValue(value);
  };

  const reference = (element: HTMLFuelTextFieldElement) => {
    localInputReference.current = element;
  };

  return <FuelTextField controlled onFuel-input={convertCustomEventToChange} name={name} ref={reference} {...props} />;
};

export const ControlledTextField = withField(TextField);
